import React from "react";
import Select from "react-select";
import { State } from "country-state-city";

const StateDropdown = ({ selectedCountry, selectedState, setSelectedState }) => {
  const countryCode =
    selectedCountry && typeof selectedCountry === "object"
      ? selectedCountry.value
      : selectedCountry;

  const stateOptions = countryCode
    ? State.getStatesOfCountry(countryCode).map((st) => ({
        value: st.isoCode,
        label: st.name,
      }))
    : [];

  return (
    <div className="form-group">
      <label htmlFor="signup-state" className="form-label">
        State
      </label>
      <Select
        id="signup-state"
        options={stateOptions}
        value={selectedState}
        onChange={(selected) => setSelectedState(selected)}
        isSearchable
        placeholder="Select State"
        styles={{
          indicatorSeparator: () => ({ display: "none" }),
          control: (base, state) => ({
            ...base,
            borderColor: state.isFocused ? "black" : "#ccc",
            boxShadow: "none",
            fontFamily: '"Rajdhani", sans-serif',
            fontWeight: 600,
            fontSize: "16px",
            "&:hover": { borderColor: "black" },
          }),
          menu: (base) => ({
            ...base,
            fontWeight: 600,
            fontSize: "16px",
            fontFamily: '"Rajdhani", sans-serif',
          }),
          option: (base) => ({
            ...base,
            fontWeight: 600,
            fontSize: "16px",
            fontFamily: '"Rajdhani", sans-serif',
            "&:hover": { backgroundColor: "var(--color-orange)", color: "var(--color-white)" },
          }),
        }}
      />
    </div>
  );
};

export default StateDropdown;
